import React from 'react';
interface HeaderProps {
  isDarkMode: boolean;
}
export const Header = ({
  isDarkMode
}: HeaderProps) => {
  return <header className="flex items-center justify-center mb-8 sm:mb-16" data-id="element-84">
      <div className="flex flex-col sm:flex-row items-center bg-white dark:bg-[#1A2332] rounded-2xl shadow-xl px-6 sm:px-10 py-6 sm:py-8 border border-gray-100 dark:border-[#2A3F5F] w-full sm:w-auto" data-id="element-85">
        <img src={isDarkMode ? 'https://uploadthingy.s3.us-west-1.amazonaws.com/mD4UhCoYDCEM2jjRqv5u6m/Logo-Master-Files-01-1-3.webp' : 'https://uploadthingy.s3.us-west-1.amazonaws.com/tGy1Hux5yMiULw6Pgp5N7z/Light_theme.png'} alt="Heliona" className="h-10 sm:h-12 mb-4 sm:mb-0" data-id="element-86" />
        <h1 className="sm:ml-6 text-2xl sm:text-4xl font-bold text-[#1A2332] dark:text-white tracking-tight text-center sm:text-left" data-id="element-87">
          Product Roadmap
        </h1>
      </div>
    </header>;
};